export const environment = {
    production: false,
    apiUrl: 'https://apitest.jaca.com.py/api/v1/dentsys',
    appName: 'DENTSYS',
    version: '1.0.0',
    tokenKey: 'dentsys_token',
    refreshTokenKey: 'dentsys_refresh_token',
    companyKey: 'dentsys_company',
    branchKey: 'dentsys_branch',
    publicBookingBaseUrl: '',
    refreshTokenExpiration: 86400000
};
